import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  isDark?: boolean;
}
export function Input({
  label,
  className = '',
  isDark = false,
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-215">
      {label && <label className={`block text-sm font-medium mb-2 ${isDark ? 'text-gray-200' : 'text-gray-900'}`} data-id="element-216">
          {label}
        </label>}
      <input className={`w-full px-4 py-3 border rounded-xl placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all duration-200 ${isDark ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300 text-gray-900'} ${className}`} {...props} data-id="element-217" />
    </div>;
}